import React, { Fragment, useContext, useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { Button, Image } from 'react-bootstrap';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import GSTDetails from 'components/sales/formSection/GSTDetails/gstDetails';
import ParkingRules from 'components/sales/formSection/parkingRules/parkingRules';
import MaterialHardware from "components/sales/formSection/editPostSaleApt/materialHardwareSection/materialHardware";
import Tags from 'components/sales/formSection/materialHardware/tags';
import AdvancePayment from 'components/sales/formSection/materialHardware/advancePayment';
import Increament from 'components/sales/formSection/materialHardware/increament';
import ShippedTo from 'components/sales/formSection/shippedTo/shippedTo';
import BilledTo from 'components/sales/formSection/billedTo/billedTo';
import OtherDetails from 'components/sales/formSection/otherDetails/otherDetails';
import GateDetails from 'components/sales/formSection/gateDetails/gateDetailsApt';
import Commercial from 'components/sales/formSection/commercial/commercial';
import Installation from 'components/sales/formSection/commercial/installation';
import Milestone from 'components/sales/formSection/mileStone/mileStone';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { handleValidateObj } from 'constants/objValues/objvalues';
import { Link } from 'react-router-dom';
import AgreementContract from 'components/sales/formSection/agreementContract/agreementContract';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import ClientDetails from "components/sales/formSection/clientDetails/clientDetails";
import InvoiceModule from 'components/sales/formSection/materialHardware/invoiceModule';
import AddPoc from "../../../../components/sales/formSection/addPoc/addPoc";
import B2BRevenue from "../../postSales/B2BRevenue";
import ContractServices from "../../postSales/ContractServices";

const EditCorpContract = (props) => {
  const {
    history,
    contractCorporate,
    contractCorpData,
    pincodeData,
    locationPinCode,
    postSalesEditCorporateLead,
    getMaterial,
    getTag,
    getTagById,
    getMateriaById,
    getBrandById,
    getBrand,
    documentUploadUrl,
    documentUrlData,
    imageUploadUrl,
    videoUploadUrl,
    match,
    supplyNameFun,
    splNameData,
    shipTolocationPinCode,
    shipToPincodeData,
    clientBillingPocData,
    clientBillingAddress,
    getContractRevenue,
    contractRevenueDetails=[],
    getContractService,
    contractCatService=[]
  } = props;
  const { params } = match;

  const postDataInputs = {
    commercial: null,
    gSTDetails: null,
    parkingRules: null,
    shippedTo: null,
    // billedTo: null,
    clientData: null,
    installation: null,
    payment:[],
    otherDetails: null,
    gateDetails: null,
    tags:[],
    category: [],
    materialHardwares: "No",
    gates: null,
    agreementDtls: null,
    InvoiceModuleData:null,
    pocData: null,
    revenue_nature: null,
    revenue_type: null,
    invoice_type:'Post',
  };
 
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [sameAsBillTo, setSameAsBillTo] = useState(null);
  const [showAgreementDetails, setShowAgreementDetails] = useState(false);
  const [agreementLength, setAgreementLength] = useState(null);
  const [isGateDetailsChanged, setIsGateDetailsChanged] = useState(false);
  const [variableServices, setVariableServices] = useState([{id:'', amount:'', qty:'', men_days:0, start_day:'', end_day:''}])
  const [fixedServices, setFixedServices] = useState([{id:'', amount:'', qty:'', men_days:0}])
  const [postCorporateData, setPostCorporateData] = useState(postDataInputs);
  const [dataCorp, setDataCorp] = useState(null);
  const [commData, setCommData] = useState(null);
  const handleCommercial = (val) => {
    setPostCorporateData({ ...postCorporateData, commercial: val });
    if (val?.totalContract) {
      setShowAgreementDetails(true);
      setAgreementLength(val?.totalContract);
      // console.log(val);
    }
  };
  const handleGstDetails = (val) => {
    setPostCorporateData({ ...postCorporateData, gSTDetails: val });
  };
  const handleParkingRules = (val) => {
    setPostCorporateData({ ...postCorporateData, parkingRules: val });
  };
  const handleGateDtl = (val) => {
    setPostCorporateData({ ...postCorporateData, gateDetails: val });
    setIsGateDetailsChanged(true);
  };
  const handleMileStone = (val) => {
    setPostCorporateData({ ...postCorporateData, milestone: val });
  };
  // const handleBillTo = (val) => {
  //   setPostCorporateData({ ...postCorporateData, billedTo: val });
  // };
  const handleClientData = (val) => {
    setPostCorporateData({ ...postCorporateData, clientData: val });
  };
  const handlePocData = (val) => {
    setPostCorporateData({ ...postCorporateData, pocData: val });
  };
  const handleInstallation = (val) => {
    setPostCorporateData({ ...postCorporateData, installation: val });
  };
  const handlePayment = (val) => {
    setPostCorporateData({ ...postCorporateData, advPayment: val });
  };

  const handleIncreament = (val) => {
    setPostCorporateData({ ...postCorporateData, increamentData: val });
  };  
  const handleShippedTo = (val) => {
    setPostCorporateData({ ...postCorporateData, shippedTo: val });
  };
  const handleOtherDetails = (val) => {
    setPostCorporateData({ ...postCorporateData, otherDetails: val });
  };
  const handleGatesData = (val) => {
    setPostCorporateData({ ...postCorporateData, categoryInventory: val });
  };
  const handleProductData = (val) => {
    setPostCorporateData({ ...postCorporateData, productInventory: val });
  };
  const handleMaterialhardware = (val) => {
    setPostCorporateData({ ...postCorporateData, materialHardwares: val });
  };
  const handleTags = (val) => {
    setPostCorporateData({ ...postCorporateData, tagsData: val });
  };
  const handleagreementDtls = (val) => {
    setPostCorporateData({ ...postCorporateData, agreementDtls: val });
  };
  const handleInvoiceAmt = (val) => {
    setPostCorporateData({ ...postCorporateData, InvoiceModuleData: val });
  }; 

  const handleModalHide = () => {
    history.push(`${baseUrl}/postSalesListing`);
    setIsModal(false);
  };

  useEffect(() => {
     if(contractCorpData !== undefined) {
        setDataCorp(contractCorpData);
     }
  },[contractCorpData]);

  useEffect(() => {
     if(dataCorp !== null) {
      const data = {
        'leadType': dataCorp?.lead_data?.lead_type_id,
        'commercialData' : {
          'commercial_type_id': dataCorp?.lead_data?.commercial_type_id
        }
      };
      setCommData(data);
     }
  },[dataCorp]);

  const handleSubmit = (id) => {
    setIsClicked(true);
    // console.log(postCorporateData);
    const {
      commercial,
      gSTDetails,
      parkingRules,
      gateDetails,
      installation,
      // billedTo,
      shippedTo,
      // clientData,
      otherDetails,
      categoryInventory,
      productInventory,
      materialHardwares,
      tagsData,
      advPayment,
      increamentData,
      agreementDtls,
      milestone,
      InvoiceModuleData,
      pocData,
      revenue_nature,
      revenue_type,
      invoice_type
    } = postCorporateData;

    if (
        commercial != null &&
        // billedTo != null &&
        // clientData !== null &&
        shippedTo != null &&
        agreementDtls != null &&
        gSTDetails != null &&
        gateDetails != null &&
        materialHardwares != null
        && pocData !== null
    ) {
      setIsClicked(false);
      setIsFiled(false);

      if(contractCorpData?.commercialData?.revenue_nature !== 'Valet' && otherDetails == null){
        alert('Please Upload missed documents or enter valid data!')
        return false
      }
      // if(clientData != null && clientData.billing_address !== undefined){
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          ...otherDetails,
          ...agreementDtls,
          // clientData: clientData,
          gateDetails: gateDetails,
          leadStatus:contractCorpData.leadStatus,
          comm_id:contractCorpData.comm_id,
          isNewContract:1,
          materialHardwares: { ...materialHardwares },
          pocData: pocData,
          // ...clientData.billing_address
        };

      // if (categoryInventory !== null && categoryInventory !== undefined) {
      //   fObj.categoryInventory = [
      //     ...categoryInventory,
      //     ...productInventory?.productData,
      //   ];
      // } else {
      //   fObj.categoryInventory = [];
      // }
      
      if((commData?.leadType === 1 || commData?.leadType === 2) && commData?.commercialData?.commercial_type_id === 5) {
        var isGettingAnyError = false;
        var inst = fObj?.installationData;
        if(inst?.consumables && inst?.consumables === 'Yes') {
          inst?.consumablesData.forEach(element => {
            if(element.name == '' || element.name == null) {
                toast.error('Consumable name is required');
                isGettingAnyError = true;
                return;
            }
            if(element?.scope == '' || element?.scope == null) {
              toast.error('Consumable scope is required');
              isGettingAnyError = true;
              return;
            }  
            if(element?.scope !== 'Client') {
                if(element.uom == '' || element.uom == null) {
                  toast.error('UOM is required for park+ scope');
                  isGettingAnyError = true;
                  return;
                }
                if(element.sales_qty == '' || element.sales_qty == null) {
                  toast.error('Quantity is required for park+ scope');
                  isGettingAnyError = true;
                  return;
                }
                if(element.unit_price == '' || element.unit_price == null) {
                  toast.error('Unit price is required for park+ scope');
                  isGettingAnyError = true;
                  return;
                }
            }
          });
          if(isGettingAnyError) {
            return;
          }
        }
      } 
      if (categoryInventory !== null && categoryInventory !== undefined && productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
          ...productInventory?.productData,
        ];
      } else if (categoryInventory !== null && categoryInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
        ];
      } else if (productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...productInventory?.productData,
        ];
      } else {
        fObj.categoryInventory = [];
      }

      if (tagsData !== null && tagsData !== undefined) {
        fObj.tags = [
          ...tagsData?.tagData,
        ];
      } else {
        fObj.tags = [];
      }

      if (advPayment !== null && advPayment !== undefined) {
        fObj.payment = [
          ...advPayment?.advData,
        ];
      } else {
        fObj.payment = [];
      }
      if (increamentData !== null && increamentData !== undefined) {
        if (increamentData?.inc?.increament_type) {
          if (increamentData?.inc?.increament_type == 'flat' || increamentData?.inc?.increament_type == 'percentage') {
            if (increamentData?.inc?.duration == undefined || increamentData?.inc?.increament_amount == undefined) {
              return false;
            }
          }
          fObj.increament = [
            increamentData
          ];
        } else {
          fObj.increament = [];
        }
      } else {
        fObj.increament = [];
      }
      if (milestone !== null && milestone != undefined) {
        let totalAmt = parseInt(postCorporateData?.commercial?.totalAmount);
        let calculatedAmt = 0;
        if (!isNaN(totalAmt)) {
          if (totalAmt > 0) {
            for (let i = 0; i < postCorporateData.milestone?.milestone_data.length; i++) {
              if (postCorporateData.milestone.milestone_data[i].amt) {
                calculatedAmt += parseInt(postCorporateData.milestone.milestone_data[i].amt);
              }
            }
            for (let i = 0; i < postCorporateData.milestone?.date_invoices_data.length; i++) {
              if (postCorporateData.milestone.date_invoices_data[i].amt) {
                calculatedAmt += parseInt(postCorporateData.milestone.date_invoices_data[i].amt);
              }
            }
            for (let i = 0; i < postCorporateData.milestone?.retention.length; i++) {
              if (postCorporateData.milestone.retention[i].amt) {
                calculatedAmt += parseInt(postCorporateData.milestone.retention[i].amt);
              }
            }
            if(calculatedAmt == 0){
              toast.error('Please Fill atleast one milestone');
              return;
            }else if (calculatedAmt > totalAmt) {console.log(totalAmt + ' <= ' + calculatedAmt);
              toast.error('Milestone total amount is greater then capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            }else if (calculatedAmt != totalAmt) {console.log(totalAmt + ' => ' + calculatedAmt);
              toast.error('Milestone total amount should be equal to capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            }
            else {
              fObj.milestone=milestone;
            }
          }
        }
      }

      fObj['revenue_nature'] = revenue_nature
      fObj['revenue_type'] = revenue_type
      fObj['invoice_type'] = invoice_type
      if(contractCorpData?.commercialData !== undefined && contractCorpData?.commercialData?.revenue_nature === 'Valet'){
        fObj['variable_services'] = variableServices
        fObj['fixed_services'] = fixedServices
      } else{
        fObj['invoice_type'] = 'Pre'
        fObj['revenue_type'] = 'Fixed'
        fObj['revenue_nature'] = 'Self'
      }


      if(InvoiceModuleData !== null && InvoiceModuleData != undefined){
        let subsAmt = Number(contractCorpData?.commercialData?.subscription_amount);
        let invoiceAmt = InvoiceModuleData?.invoiceAmt;
        const initialValue = 0;
        const sumWithInitial = invoiceAmt.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
        );
        console.log(sumWithInitial);
        if(subsAmt === sumWithInitial ){
          fObj.InvoiceModuleData=InvoiceModuleData;
        }else{
          toast.error('Total amount of invoice module is not equal to the total subscription amount!');
          setIsClicked(false);
          setIsFiled(true);
          return;
        }
       

      }
      
    // console.log(fObj); return false;
      (async () => {
        const res = await postSalesEditCorporateLead({ ...fObj, leadId: parseInt(params.manageId), comm_id: parseInt(params.id)});
        if (res) {
          setIsModal(true);
        }
      })();
      
    } else {
      // console.log('false');
      setIsClicked(false);
      setIsFiled(true);
      const active = document.querySelector('.activeAnkInput');
      console.log(active);
      if(active){
        active.focus();
      }else{
        alert('Please Upload missed documents or enter valid data!')
      }
    }
  };

  useEffect(() => {
    (async () => {
        await contractCorporate(params)
       await getContractRevenue()
      await getContractService('VALET')
    })();
  }, [contractCorporate]);

  function refreshPage() {
    window.location.reload(false);
  }

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">
          {localization.save}
        </Button>
        <Button onClick={() => handleSubmit(params.lead_id)} disabled={isClicked}>
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight} />
        </Button>
      </Fragment>
    );
  };

  const handleRevenueDetails = (key, value) => {
    postCorporateData[key] = value
    setPostCorporateData(postCorporateData);
  }

  const handleVariableService = (index, key, val) => {
    let list = [...variableServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      variableServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setVariableServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setVariableServices(list)
  }

  const handleFixedService = (index, key, val) => {
    let list = [...fixedServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      fixedServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setFixedServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setFixedServices(list)
  }

  useEffect(() => {
    if(contractCorpData?.valet_contract_variable_service !== undefined && contractCorpData?.contractAptData !== null && Object.keys(contractCorpData?.valet_contract_variable_service).length > 0){
      setVariableServices(contractCorpData?.valet_contract_variable_service)
    }

    if(contractCorpData?.valet_contract_fixed_service !== undefined && Object.keys(contractCorpData?.valet_contract_fixed_service).length > 0){
      setFixedServices(contractCorpData?.valet_contract_fixed_service)
    }
  }, [contractCorpData])
   
  // 
  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      className={isFiled ? 'requiredFileds' : ''}
      title={localization.editContract}
    >
      {(contractCorpData !== undefined || contractCorpData !== null) && (
        <>

        <B2BRevenue
            RevenueData={contractRevenueDetails}
            handleValue={handleRevenueDetails}
            commercialData={contractCorpData.commercialData}
            isEditable={true}
        />
      <Commercial
        data={contractCorpData}
        handleValue={handleCommercial}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        supplyNameFun={supplyNameFun}
        splNameData={splNameData}
        edit={1}
        prefilledData={contractCorpData.postsale_data}
      />
      <AgreementContract
        handleValue={handleagreementDtls}
        documentUploadUrl={documentUploadUrl}
        agreementLength={agreementLength}
        showDetails={showAgreementDetails}
        prefilledData={contractCorpData.postsale_data}
      />
      <GSTDetails
        handleValue={handleGstDetails}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        prefilledData={contractCorpData.postsale_data}
      />
       {/* <BilledTo
        handleValue={handleBillTo}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
      />

      <Checkbox
        label={'Same shipping address'}
        type="checkbox"
        errorMsg={localization.isRequired}
        onChange={(val) => {
          if (val) {
            setSameAsBillTo(postCorporateData.billedTo);
          } else {
            setSameAsBillTo({
              billPinCode: '',
              billGeoCity: '',
              billGeoState: '',
              billGeoCityId: '',
              billGeoStateId: '',
              billPinId: '',
              billAddressLine1: '',
              billAddressLine2: '',
            });
          }
        }}
      /> */}
      <ShippedTo
        handleValue={handleShippedTo}
        locationPinCode={shipTolocationPinCode}
        pincodeData={shipToPincodeData}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        leadData={contractCorpData.lead_name}
        prefilledData={contractCorpData.postsale_data}
        clientBrd={contractCorpData?.commercialData?.client_brd}
      />
      
      <AddPoc
        handleValue={handlePocData}
        prefilledData={contractCorpData}
      />
      {/* <ClientDetails
        handleValue={handleClientData}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        data={contractCorpData}
        clientBillingAddress={clientBillingAddress}
        clientBillingPocData={clientBillingPocData}
      /> */}
       {contractCorpData?.commercialData !== undefined && contractCorpData?.commercialData?.revenue_nature !== 'Valet' &&
          <ParkingRules
            handleValue={handleParkingRules}
            data={contractCorpData}
            prefilledData={contractCorpData.postsale_data}
          />
       }
      
       <GateDetails
        handleValue={handleGateDtl}
        data={contractCorpData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
        prefilledData={contractCorpData.postsale_data}
      />
      {(contractCorpData.commercialData?.commercial_type_id === 7 || contractCorpData.commercialData?.commercial_type_id === 6) && (
        <InvoiceModule
          handleValue={handleInvoiceAmt}
          data={contractCorpData}
          prefilledData={contractCorpData.postsale_data} 
          invoiceAmtData = {contractCorpData.postsale_data}
          isdisable={false}
        />
      )}
      {contractCorpData.commercialData?.commercial_type_id === 5 && (
          <Milestone
            handleValue={handleMileStone}
            totalAmount={postCorporateData.commercialData}
            gateData={postCorporateData?.gateDetails}
            gateDetailsChanged = {setIsGateDetailsChanged} 
            isGateDetailsChanged = {isGateDetailsChanged} 
            prefilledData={contractCorpData.postsale_data}
          />
      )}
       {contractCorpData?.commercialData !== undefined && contractCorpData?.commercialData?.revenue_nature !== 'Valet' &&
          <MaterialHardware
              handleValue={handleMaterialhardware}
              data={contractCorpData}
              handleGatesData={handleGatesData}
              handleProductData={handleProductData}
              getMaterial={getMaterial}
              getMateriaById={getMateriaById}
              getBrandById={getBrandById}
              getBrand={getBrand}
              prefilledData={contractCorpData.postsale_data}
              editProduct={true}
              commData={dataCorp}
          />
       }
          {contractCorpData?.commercialData !== undefined && contractCorpData?.commercialData?.revenue_nature === 'Valet' &&
              <ContractServices
                  serviceDetails={contractCatService}
                  setVariableServices={setVariableServices}
                  variableServices={variableServices}
                  handleVariableService={handleVariableService}
                  handleFixedService={handleFixedService}
                  handleValue={handleRevenueDetails}
                  setFixedServices={setFixedServices}
                  fixedServices={fixedServices}
                  commercialData={contractCorpData?.commercialData}
              />
          }

       {contractCorpData?.commercialData !== undefined && contractCorpData?.commercialData?.revenue_nature !== 'Valet' &&
          <Tags
            handleValue={handleTags}
            data={contractCorpData}
            prefilledData={contractCorpData.postsale_data}
          />
       }

       {contractCorpData?.commercialData !== undefined && contractCorpData?.commercialData?.revenue_nature !== 'Valet' && contractCorpData?.commercialData?.solution_type !== 3 &&
          <Installation
              handleValue={handleInstallation}
              isApartment={true}
              prefilledData={contractCorpData.postsale_data}
              commData={commData}
            />
       }

    <AdvancePayment
        handleValue={handlePayment}
        data={contractCorpData}
        imageUploadUrl={imageUploadUrl}
        prefilledData={contractCorpData.postsale_data}
      />

       {contractCorpData?.commercialData !== undefined && contractCorpData?.commercialData?.revenue_nature !== 'Valet' && contractCorpData?.commercialData?.solution_type !== 3 &&
        <Increament
            handleValue={handleIncreament}
            data={contractCorpData}
            imageUploadUrl={imageUploadUrl}
            prefilledData={contractCorpData.postsale_data}
          />
       }

       {contractCorpData?.commercialData !== undefined && contractCorpData?.commercialData?.revenue_nature !== 'Valet' &&
          <OtherDetails
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            handleValue={handleOtherDetails}
            data={contractCorpData}
            imageUploadUrl={imageUploadUrl}
            videoUploadUrl={videoUploadUrl}
            prefilledData={contractCorpData.postsale_data}
          />
       }
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <button onClick={refreshPage} className="btn btn-primary mb-4">
          {localization.saveAndNext} <img src={Images?.ArrowRight} alt="" />
          </button>
          {/* <Link
            to={`${baseUrl}/post-sales-corporate/${contractCorpData.leadId}`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link> */}
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
      </>
)}

    </Layout>
  );
};

EditCorpContract.propTypes = {
  history: propTypes.any,
  postCorporate: propTypes.func,
};

export default EditCorpContract;
